import { Routes } from '@angular/router';

export const SALES_PIPELINE_ROUTES: Routes = [
  {
    path: 'sales-pipeline',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/sales-pipeline/sales-pipeline-directory/sales-pipeline-directory.component').then(
            (c) => c.SalesPipelineDirectoryComponent,
          ),
        data: { layout: 'private' },
      },
    ],
  },
];
